export class DownloadParameterRequestTO {
	public nombreParametro!: String;
	public subTipoParametro!: String;
	public valorParametro!: String;
	public descripcion!: String;
}